import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as PointCompleteAPI from "@/api/analysis/point-complete";
import { isSuccess } from "@/api/response";
import { PointCompleteGetRequest } from "@/api/analysis/point-complete/request";
import {
  PointCompleteGetResponse,
  PointCompleteGetResult
} from "@/api/analysis/point-complete/response";
import { AnalysisGraphData } from "@/api/analysis/common/response";

const MODULE_NAME = "analysis/point-complete/get";

/**
 *  ポイントコンプリートチケット情報取得API（analysis-point-complete）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getRequest: PointCompleteGetRequest = {} as PointCompleteGetRequest;
  getResponse: PointCompleteGetResponse = {} as PointCompleteGetResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getData() {
    if (this.getResponse.results) {
      return this.getResponse.results.data;
    } else {
      return {} as AnalysisGraphData;
    }
  }

  get getTotalCount() {
    if (this.getResponse.results) {
      return this.getResponse.results.totalCount;
    } else {
      return 0;
    }
  }

  get getGetRequest() {
    return this.getRequest;
  }
  // MutationActions
  @MutationAction
  async get(getRequest: PointCompleteGetRequest) {
    const getResponse = await PointCompleteAPI.get(getRequest);
    return {
      getResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as PointCompleteGetResponse
    };
  }
}

export default getModule(Get);
